import { CalloutType } from '../../components/AutoGenerate/types/AutomatedExperience'
import { CalloutSkin, CalloutEmphasis, SupportedMerchandisingTagType } from '../../types/Callout'

interface CalloutSkinStrategy {
  resolveSkin: (tagType?: SupportedMerchandisingTagType) => CalloutSkin
  resolveEmphasis: () => CalloutEmphasis
}

class OutOfStockCalloutStrategy implements CalloutSkinStrategy {
  resolveSkin(): CalloutSkin {
    return 'info'
  }

  resolveEmphasis(): CalloutEmphasis {
    return 'low'
  }
}

class DefaultCalloutStrategy implements CalloutSkinStrategy {
  resolveSkin(): CalloutSkin {
    return 'info'
  }

  resolveEmphasis(): CalloutEmphasis {
    return 'standard'
  }
}

class TagCalloutStrategy implements CalloutSkinStrategy {
  private tagTypeSkinOverrides: Record<SupportedMerchandisingTagType, CalloutSkin> = {
    [SupportedMerchandisingTagType.NEW_LOW_PRICE]: 'promo',
    [SupportedMerchandisingTagType.NEW]: 'accent',
    [SupportedMerchandisingTagType.NEW_OPTIONS]: 'accent'
  }

  resolveSkin(tagType?: SupportedMerchandisingTagType): CalloutSkin {
    return this.tagTypeSkinOverrides[tagType as SupportedMerchandisingTagType] ?? 'accent'
  }
  resolveEmphasis(): CalloutEmphasis {
    return 'standard'
  }
}

function getCalloutStrategy(calloutType?: CalloutType): CalloutSkinStrategy {
  switch (calloutType) {
    case CalloutType.CAMPAIGN:
      return new DefaultCalloutStrategy()
    case CalloutType.OUT_OF_STOCK:
      return new OutOfStockCalloutStrategy()
    case CalloutType.TAG:
      return new TagCalloutStrategy()
    default:
      return new DefaultCalloutStrategy()
  }
}

export function resolveCalloutSkin(
  calloutType?: CalloutType,
  tagType?: SupportedMerchandisingTagType
): CalloutSkin {
  const strategy = getCalloutStrategy(calloutType)
  return strategy.resolveSkin(tagType)
}

export function resolveCalloutEmphasis(calloutType?: CalloutType): CalloutEmphasis {
  const strategy = getCalloutStrategy(calloutType)
  return strategy.resolveEmphasis()
}
